import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getSaleInvoiceBranch,
  getSaleInvoiceBranchById,
  getParticularPage,
  getSaleOrderDetail,
  getNext,
  getPrevious,
  handleSearch,
  createSaleInvoiceBranch,
} from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";

const initialState = {
  saleInvoiceBranches: [],
  edit: false,
  saleInvoiceBranch: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingSaleInvoiceBranch: false,
  loadingNext: false,
  loadingDetails: false,
  saleInvoiceBranchDetails: [],
  showCreateModal: false,
};

export const saleInvoiceBranchSlice = createSlice({
  name: "saleInvoiceBranch",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    saleInvoiceBranchDetailsUpdated: (state, action) => {
      state.saleInvoiceBranchDetails = action.payload;
    },
    clearSaleInvoiceBranchDetails: (state, action) => {
      state.saleInvoiceBranchDetails = [];
    },

    clearSaleInvoiceBranchDetails: (state) => {
      state.saleInvoiceBranchDetails = [];
    },
    clearAllSaleInvoiceBranch: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingSaleInvoiceBranch = false;
      state.saleInvoiceBranch = null;
      state.saleInvoiceBranchDetails = [];
    },
  },
  extraReducers: (builder) => {
    // get
    builder.addCase(createSaleInvoiceBranch.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createSaleInvoiceBranch.fulfilled, (state, action) => {
      state.loadingCreate = false;
    });
    builder.addCase(createSaleInvoiceBranch.rejected, (state) => {
      state.loadingCreate = false;
    });
    builder.addCase(getSaleOrderDetail.pending, (state) => {
      state.loadingDetails = true;
      state.saleInvoiceBranch = null;
      state.saleInvoiceBranchDetails = null;
    });
    builder.addCase(getSaleOrderDetail.fulfilled, (state, action) => {
      state.loadingDetails = false;
      state.saleInvoiceBranch = action.payload.data;
      state.saleInvoiceBranchDetails = action.payload.data?.goodReceiptNotesDetails;
    });
    builder.addCase(getSaleOrderDetail.rejected, (state) => {
      state.loadingDetails = false;
      state.saleInvoiceBranch = null;
      state.saleInvoiceBranchDetails = null;
    });
    // getSaleInvoiceBranchById
    builder.addCase(getSaleInvoiceBranchById.pending, (state) => {
      state.loading = true;
      state.saleInvoiceBranch = null;
    });
    builder.addCase(getSaleInvoiceBranchById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.saleInvoiceBranch = action.payload.data;

      state.saleInvoiceBranchDetails = action.payload.data?.saleOrderDetails.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(getSaleInvoiceBranchById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.saleInvoiceBranch = null;
    });
    builder.addMatcher(
      isAnyOf(
        getSaleInvoiceBranch.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingSaleInvoiceBranch = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getSaleInvoiceBranch.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingSaleInvoiceBranch = false;
        state.saleInvoiceBranches = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getSaleInvoiceBranch.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingSaleInvoiceBranch = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  goToPage,
  saleInvoiceBranchDetailsUpdated,
  clearSaleInvoiceBranchDetails,
  clearAllSaleInvoiceBranch,
} = saleInvoiceBranchSlice.actions;

export default saleInvoiceBranchSlice.reducer;
